import React from "react";

import type { Territory } from "../../graphql-types";
import Image from "./GatsbyImage";
import { VideoPlayer } from "./VideoPlayer";

type Props = {
  territoryWidget: Pick<
    Territory,
    | "topHeading"
    | "topCopy"
    | "topHeroImage"
    | "topLeftHeadingImage"
    | "bottomHeading"
    | "bottomGraphic"
    | "graphicHeading"
  >;
};

export function TerritoryWidget({
  territoryWidget: {
    topHeading,
    topCopy,
    topHeroImage,
    topLeftHeadingImage,
    bottomHeading,
    bottomGraphic,
    graphicHeading,
  },
}: Props) {
  return (
    <>
      <section className="relative pb-10 text-center z-400">
        {bottomHeading && (
          <h2 className="px-3 py-2 text-2xl font-extrabold text-center uppercase rounded mt-14 bg-[#f8f800]">
            {bottomHeading}
          </h2>
        )}
        {bottomGraphic?.localFile.publicURL && (
          <figure className="bg-[#102542]">
            <div className="py-10 text-center">
              <img
                className="inline-block"
                style={{ maxWidth: 200 }}
                src={bottomGraphic.localFile.publicURL}
                alt={bottomGraphic.description || ""}
              />
            </div>
            {graphicHeading && (
              <figcaption
                className="inline-block pt-3 pb-6 text-xl font-bold text-white"
                style={{ borderTop: "3px solid #fff116" }}
              >
                {graphicHeading}
              </figcaption>
            )}
          </figure>
        )}
      </section>
      <section className="relative pt-10 text-center z-400">
        {topHeading && (
          <h2 className="px-2 pb-2 mb-10 text-3xl font-extrabold uppercase">
            {topHeading}
          </h2>
        )}
        {(topHeroImage?.localFile.childImageSharp ||
          topHeroImage?.cdnVideo) && (
          <figure className="max-w-container mx-auto relative">
            {topHeroImage.localFile.childImageSharp && (
              <Image
                image={topHeroImage.localFile.childImageSharp.gatsbyImageData}
                alt={topHeroImage.description || ""}
              />
            )}
            {topLeftHeadingImage?.localFile.childImageSharp && (
              <Image
                image={
                  topLeftHeadingImage.localFile.childImageSharp.gatsbyImageData
                }
                alt={topLeftHeadingImage?.description || ""}
                style={{ position: "absolute", top: 20, left: 20 }}
                className="w-24 md:ml-16 md:mt-6 md:w-64"
              />
            )}
            {topHeroImage.cdnVideo && (
              <VideoPlayer
                data-testid="territory-video"
                path={topHeroImage.cdnVideo.path}
                poster={topHeroImage.cdnVideo.posterPath}
                className="w-full"
              />
            )}
          </figure>
        )}
        {topCopy && (
          <figcaption className="max-w-md px-10 mb-10 text-xl font-medium pt-14 mx-auto">
            {topCopy}
          </figcaption>
        )}
      </section>
    </>
  );
}
